<template>
  <div class="container my-4">
    <h2 class="text-center mb-4 text-primary">Teacher Details</h2>

    <div v-if="teacher" class="card shadow rounded p-4">
      <div class="row align-items-center">
        <div class="col-md-4 text-center mb-3 mb-md-0">
          <img
            :src="teacher.user.profile_photo_url"
            alt="Profile Photo"
            class="img-fluid rounded-circle border"
            style="width: 150px; height: 150px; object-fit: cover;"
          />
        </div>

        <div class="col-md-8">
          <p class="mb-2"><strong>Name:</strong> {{ teacher.user.first_name }} {{ teacher.user.last_name }}</p>
          <p class="mb-2"><strong>Email:</strong> {{ teacher.user.email }}</p>
          <p class="mb-2"><strong>NIC:</strong> {{ teacher.teacher_nic }}</p>
          <p class="mb-2"><strong>Birth Date:</strong> {{ teacher.birth_day }}</p>
          <p class="mb-2"><strong>Address:</strong> {{ teacher.address }}</p>
          <p class="mb-0"><strong>Contact:</strong> {{ teacher.contact }}</p>
        </div>
      </div>
    </div>

    <div v-else class="text-center text-muted mt-5">
      <div class="spinner-border text-primary mb-3" role="status"></div>
      <div>Loading teacher details...</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    teacherId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      teacher: null
    };
  },
  mounted() {
    this.fetchTeacher();
  },
  methods: {
    fetchTeacher() {
      axios
        .get('/get-teacher-details-by-id', {
          headers: {
            'Teacher-ID': this.teacherId
          }
        })
        .then(response => {
          this.teacher = response.data;
        })
        .catch(error => {
          console.error('Error fetching teacher:', error);
        });
    }
  }
};
</script>

<style scoped>
.card {
  background-color: #ffffff;
  border-radius: 15px;
}
</style>
